import Vue from 'vue';
import Vuex, { Commit } from 'vuex';

Vue.use(Vuex);

type NavigationState = {
	isMenuActive: boolean;
	active1stLayer: string | undefined;
	active2ndLayer: number | undefined;
};

export const navigationStore = {
	namespaced: true,
	state: {
		isMenuActive: false,
		active1stLayer: undefined,
		active2ndLayer: undefined,
	},
	mutations: {
		SET_IS_MENU_ACTIVE(state: NavigationState, newState: NavigationState) {
			state.isMenuActive = newState.isMenuActive;
		},
		SET_ACTIVE_2ND_LAYER(state: NavigationState, newState: NavigationState) {
			state.active2ndLayer = newState.active2ndLayer;
		},
		SET_ACTIVE_1ST_LAYER(state: NavigationState, newState: NavigationState) {
			state.active1stLayer = newState.active1stLayer;
		},
	},
	actions: {
		updateMenuState({ commit, state }: { commit: Commit; state: NavigationState }, isMenuActive: boolean) {
			commit('SET_IS_MENU_ACTIVE', {
				...state,
				isMenuActive,
			});
		},
		setActive1stLayer({ commit, state }: { commit: Commit; state: NavigationState }, newState: NavigationState) {
			commit('SET_ACTIVE_1ST_LAYER', {
				...state,
				...newState,
			});
		},
		setActive2ndLayer({ commit, state }: { commit: Commit; state: NavigationState }, newState: NavigationState) {
			commit('SET_ACTIVE_2ND_LAYER', {
				...state,
				...newState,
			});
		},
	},
};
